import React from "react";
import { Box, Typography, TextField, Button, IconButton } from "@mui/material";
import { Add as AddIcon, Remove as RemoveIcon } from "@mui/icons-material";
import { AdditionalPerson } from "@/types";

interface AdditionalPeopleEditorProps {
  people: AdditionalPerson[];
  onAdd: () => void;
  onRemove: (index: number) => void;
  onChange: (
    index: number,
    field: "name" | "surname" | "email",
    value: string,
  ) => void;
}

const AdditionalPeopleEditor: React.FC<AdditionalPeopleEditorProps> = ({
  people,
  onAdd,
  onRemove,
  onChange,
}) => (
  <Box>
    <Box
      sx={{
        display: "flex",
        justifyContent: "space-between",
        alignItems: "center",
        mb: 2,
      }}
    >
      <Typography variant="subtitle1" sx={{ fontWeight: 600 }}>
        Additional People ({people.length})
      </Typography>
      <Button
        variant="outlined"
        startIcon={<AddIcon />}
        onClick={onAdd}
        size="small"
      >
        Add Person
      </Button>
    </Box>

    {people.map((person, index) => (
      <Box
        key={index}
        sx={{
          mb: 2,
          p: 2,
          border: "1px solid",
          borderColor: "divider",
          borderRadius: 1,
        }}
      >
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            mb: 2,
          }}
        >
          <Typography variant="body2" sx={{ fontWeight: 500 }}>
            Person {index + 1}
          </Typography>
          <IconButton
            size="small"
            color="error"
            onClick={() => onRemove(index)}
          >
            <RemoveIcon />
          </IconButton>
        </Box>

        <Box sx={{ display: "flex", gap: 2, flexWrap: "wrap" }}>
          <TextField
            label="Name"
            value={person.name}
            onChange={(e) => onChange(index, "name", e.target.value)}
            required
            sx={{ flex: 1, minWidth: 200 }}
          />
          <TextField
            label="Surname"
            value={person.surname}
            onChange={(e) => onChange(index, "surname", e.target.value)}
            required
            sx={{ flex: 1, minWidth: 200 }}
          />
          <TextField
            label="Email"
            type="email"
            value={person.email}
            onChange={(e) => onChange(index, "email", e.target.value)}
            required
            sx={{ flex: 1, minWidth: 200 }}
          />
        </Box>
      </Box>
    ))}
  </Box>
);

export default AdditionalPeopleEditor;
